//https://github.com/Shenato/react-tournament-brackets/blob/master/src/components/match/index.tsx

import classNames from 'classnames';
import React from 'react';

export function Match({
	bottomHovered,
	bottomParty,
	bottomText,
	bottomWon,
	match,
	onMatchClick,
	onMouseEnter,
	onMouseLeave,
	onPartyClick,
	topHovered,
	topParty,
	topText,
	topWon,
}) {
	return (
		<div className='bracket__bracketMatch'>
			<div className='bracket__details'>
				
				<div className={classNames('bracket__side', topWon && 'bracket__side-winner' )}>
					<h1 className={'bracket__side-name'}>{topParty?.name}</h1>
					<h1 className={classNames('bracket__side-score')}>{topParty?.resultText}</h1>
				</div>
				<div className='bracket__line'></div>
				<div className={classNames('bracket__side', bottomWon && 'bracket__side-winner' )}>
					<h1 className='bracket__side-name'>{bottomParty?.name}</h1>
					<h1 className='bracket__side-score'>{bottomParty?.resultText}</h1>
				</div>
			</div>

		</div>
	);
}